import styled from 'styled-components';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-15ilxir-0"
})(["width:100%;padding:40px 0;display:flex;flex-direction:column;min-height:44px;align-items:center;"]);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-15ilxir-1"
})(["max-width:1320px;width:90%;margin:auto;display:flex;position:relative;align-items:center;"]);
const Anchor = styled.a.withConfig({
  displayName: "style__Anchor",
  componentId: "sc-15ilxir-2"
})(["font-family:'Sanomat Sans';font-style:normal;font-weight:400;font-size:14px;text-decoration:underline;margin-left:2px;cursor:pointer;"]);
const Headline = styled.span.withConfig({
  displayName: "style__Headline",
  componentId: "sc-15ilxir-3"
})(["font-family:'Sanomat Sans';font-style:normal;font-weight:700;font-size:16px;"]);
const SubHeadline = styled.span.withConfig({
  displayName: "style__SubHeadline",
  componentId: "sc-15ilxir-4"
})(["font-family:'Sanomat Sans';font-style:normal;font-weight:400;font-size:14px;"]);
const Image = styled.img.withConfig({
  displayName: "style__Image",
  componentId: "sc-15ilxir-5"
})(["max-width:209px;margin-top:10px;margin-bottom:10px;"]);
export { Image, SubHeadline, Headline, Anchor, InnerWrapper, Wrapper };